import React from 'react';
import { createRoot } from 'react-dom/client';
import UserPage from '../components/tournaments/UserPage.jsx';
import TournamentsLayout from '../components/tournaments/TournamentsLayout.jsx';

const params = new URLSearchParams(window.location.search);
const username = params.get('u') || '';

const root = createRoot(document.getElementById('root'));
root.render(
  <TournamentsLayout active="user">
    <UserPage username={username} />
  </TournamentsLayout>
);
